import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import styles from "./Quizicon.module.css";

function Quizicon() {
  const [showMessage, setShowMessage] = useState(false);
  const router = useRouter();

  const handleAccept = () => {
    localStorage.removeItem("recommendedProducts");
    localStorage.removeItem("quizAnswers");
    localStorage.removeItem("quiz_user_email");

    router.push("/quiz");
  };

  const handleDecline = () => {
    setShowMessage(false);
  };

  const handleIconClick = () => {
    setShowMessage(true);
  };

  useEffect(() => {
    if (router.pathname === "/") {
      setShowMessage(true);
    }
  }, [router.pathname]);

  // Optional: Hide quiz icon completely on specific pages
  const hideQuiz = router.components?.[router.pathname]?.Component?.hideQuiz;
  if (hideQuiz) {
    return null;
  }

  return (
    <div className={styles.quizeMain}>
      <div className={styles.burst}></div>
      <div className={styles.burst2}></div>

      <img
        className={styles.quizIcon}
        src="/images/Quiz_svg.svg"
        alt="Quiz-icon"
        onClick={handleIconClick}
      />

      {showMessage && (
        <div className={styles.messageBox}>
          <div className={styles.closeBtn} onClick={handleDecline}>
            X
          </div>
          <p className={styles.messageText}>
            Find Your Mediterranean Wellness Path
            <br />
            Take the Bruno MD Quiz for tailored health support <br />
            Enjoy 30% OFF <br />
            (20% + extra 10% with Subscribe & Save) <br />
            Rooted in science. Designed for longevity.
          </p>
          <div className={styles.actionButtons}>
            <button onClick={handleAccept} className={styles.acceptBtn}>
              Take the Quiz
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Quizicon;
